<template lang="html">
    <section class="history">
        <v-btn :to="`/send/${app}`" color="success" large class="action-button ma-5" v-if="hasPermission">
            <v-icon>
                mdi-plus
            </v-icon>
            התראה חדשה
        </v-btn>
        <v-data-table :headers="headers" :items="history" :items-per-page="50" class="elevation-1" @click:row="edit" @pagination="page">
            <template v-slot:item.sound="{ item }">
                    <v-icon v-if="item.sound">mdi-volume-high</v-icon>
                    <v-icon v-else>mdi-volume-off</v-icon>
            </template>

            <template v-slot:item.image="{ item }">
                <a :href="item.image" target="_blank">
                                <img :src="item.image" class="image"/>
                                </a>
            </template>

            <template v-slot:item.deeplink="{ item }">
                {{item.deeplink && item.deeplink.label}}
            </template>

            <template v-slot:item.segment="{ item }">
                <v-chip v-for="s in item.segment">
                    {{s}}</v-chip>
            </template>

            <template v-slot:item.sent="{ item }">
                {{item.status}}
                </br>
                {{item.sent.split(" ")[1]}}
                </br>
                {{item.sent.split(" ")[0]}}
            </template>
                            <!--
            <template v-slot:item.actions="{ item }">
                <div class="actions">
                    <v-btn :to="`/send/${app}?template=${item.id}`" v-if="item.type == 'draft'" color="primary" large class="action-button">
                        <v-icon class="ml-4">
                            mdi-pencil
                        </v-icon>
                        ערוך טיוטה
                    </v-btn>
                    <v-btn :to="`/send/${app}?template=${item.id}&copy=true`" v-else color="success" large class="action-button d-flex">
                        <v-icon class="ml-1">
                            mdi-send
                        </v-icon>
                        שליחה חוזרת
                    </v-btn>
                    <v-icon class="mr-2" color="error" @click="deleteItem(item)">
                        mdi-delete
                    </v-icon>
                </div>
            </template>
                            -->

            <template v-slot:item.sentData="{ item }">
                <div v-if="item.sentData && item.sentData.push_notification_opened" class="sentData">
                    <div class="delivery_text"> נתקבלו: {{ item.sentData.notification_receive }}</div>
                    <div class="opens_text"> קליקים: {{ item.sentData.push_notification_opened }}</div>
                    <!--<div class="dismis_text"> נסגרו: {{item.sentData.notification_dismiss }}</div>-->
                    <div class="delivery" style="width:100%">
                        <div class="opens" :style="`width:${ item.sentData.notification_open / item.sentData.notification_receive * 100 }%`"></div>
                        <!--<div class="dismis" :style="`width:${ item.sentData.notification_dismiss / item.sentData.notification_receive * 100 }%`"></div>-->
                    </div>
                </div>
            </template>
        </v-data-table>
    </section>
</template>

<script lang="js">
export default {
    name: 'history',
    props: [],
    mounted() {
        const vm = this
    },
    data() {
        return {
            headers: [{
                    text: 'תמונה',
                    value: 'image'
                }, {
                    text: 'כותרת',
                    value: 'title'
                },
                {
                    text: 'גוף ההודעה',
                    value: 'body'
                },
                {
                    text: 'קבוצות',
                    value: 'segment'
                },
                {
                    text: 'Deeplink',
                    value: 'deeplink'
                },
                {
                    text: 'קול',
                    value: 'sound'
                },
                // {
                //     text: 'מיקום',
                //     value: 'location'
                // },
                // {
                //     text: 'תבנית',
                //     value: 'theme'
                // },
                {
                    text: 'סטטוס',
                    value: 'sent'
                },
                {
                    text: 'נתוני שליחה',
                    value: 'sentData'
                },
                // {
                //     value: 'actions'
                // },

            ],
        }
    },
    methods: {
        deleteItem(item) {
            this.$store.dispatch('deleteNotify', item.id)
        },
        edit(item) {
            if (item.type == 'draft') {
                this.$router.push({ path: `/send/${this.app}?template=${item.id}` })
            }
        },
        page(pagination) {
            const currentItems = this.history.slice(pagination.pageStart, pagination.pageStop)
            if (currentItems.length == 0) return
            const filter = { messageIds: [], ids: [] }
            currentItems.forEach(function(a) {
                filter.messageIds.push(a.messageId)
                filter.ids.push(a.id)
            })
            filter.startDate = currentItems.at(-1).sent.split(" ")[0]

            filter.endDate = new Date(currentItems.at(0).sent)
            filter.endDate.setDate(filter.endDate.getDate() + 2)
            filter.endDate = filter.endDate.toISOString().split("T")[0]

            this.$store.dispatch('fetchNotificationData', {
                items: filter
            })
        }
    },
    computed: {
        history() {
            return Object.values(this.$store.getters.history).filter(x => x.app == this.app)
        },
        app() {
            return this.$route.params.app
        },
        hasPermission() {
            const segments = this.$store.getters.userClaims.segments
            if (!segments) {
                return false
            }
            if (this.app == "kan") {
                return segments.filter(x => x != 'hinuchitMain' && x != 'stickersMain').length
            } else {
                return segments.includes(`${this.app}Main`)
            }
        }

    }
}
</script>

<style lang="scss">
.image {
    height: 90px;
    width: 160px;
}

.actions {
    display: flex;
}

.v-btn__content {
    // flex-direction: column !important;
}

.delivery {
    height: 15px;
    background-color: aquamarine;
    display: flex
}

.opens {
    height: 15px;
    background-color: green;
}

.dismis {
    height: 15px;
    background-color: red;
}

.opens_text {
    color: green;
}

.dismis_text {
    color: red;
}

.sentData {
    display: flex;
    flex-direction: column;
}

.text-start {
    max-width: 200px;
    word-break: break-word;
}
</style>
